import { type HTMLProps, memo } from "react";
import "Components/Global/AuthCard/AuthCard.less";

type AuthCardProps = HTMLProps<HTMLFormElement>;

function AuthCard({ children, ...restFormProps }: AuthCardProps) {
	return (
		<div className="auth-card">
			<div className="header" />
			<form className="auth-form" noValidate { ...restFormProps }>
				{ children }
			</form>
		</div>
	);
}

export default memo(AuthCard);
